export { DOMOverlayRenderer } from './dom-modal-renderer';
export { Modal } from './modal';
export { DOMOutsideEventPlugin } from './outside-event-plugin';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/src/providers/index.js
// module id = 8
// module chunks = 0